var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('preview-section'),_c('requirements-section'),_c('advantages-section'),_c('start-section'),_c('faq-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }